module.exports = __webpack_public_path__ + "img/fenyxconsult_logo.27c6ee26.png";